import { isSessionSelectable } from './isSessionSelectable';

export function isSessionSelected(session) {
    return !isSessionSelectable(session) || session.is_selected;
}
